"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var frame_1 = require("../../frame");
// STOMP protocol with the V1_0
var stompProtocolV1_0 = function () {
    var counter = 0;
    var getMessageId = function (frame) {
        return frame.headers['message-id'];
    };
    var getSubscription = function (frame) {
        return frame.headers.subscription;
    };
    // [CONNECTED Frame](http://stomp.github.com/stomp-specification-1.1.html#CONNECTED_Frame)
    var connect = function (headers) {
        return frame_1.default.marshall('CONNECT', headers);
    };
    // [DISCONNECT Frame](http://stomp.github.com/stomp-specification-1.1.html#DISCONNECT)
    var disconnect = function (headers) {
        if (headers === void 0) { headers = {}; }
        return frame_1.default.marshall('DISCONNECT');
    };
    // [SEND Frame](http://stomp.github.com/stomp-specification-1.1.html#SEND)
    //
    // * 'destination' is MANDATORY.
    var send = function (headers, body) {
        if (headers === void 0) { headers = {}; }
        if (body === void 0) { body = ''; }
        return frame_1.default.marshall('SEND', headers, body);
    };
    // [BEGIN Frame](http://stomp.github.com/stomp-specification-1.1.html#BEGIN)
    //
    // If no transaction ID is passed, one will be created automatically
    var begin = function (transaction) {
        if (transaction === void 0) { transaction = "tx-" + counter++; }
        return frame_1.default.marshall('BEGIN', { transaction: transaction });
    };
    // [COMMIT Frame](http://stomp.github.com/stomp-specification-1.1.html#COMMIT)
    //
    // * 'transaction' is MANDATORY.
    //
    // It is preferable to commit a transaction by calling 'commit()' directly on
    // the object returned by 'client.begin()':
    //
    //     var tx = client.begin(txid);
    //     ...
    //     tx.commit();
    var commit = function (transaction) {
        return frame_1.default.marshall('COMMIT', { transaction: transaction });
    };
    // [ABORT Frame](http://stomp.github.com/stomp-specification-1.1.html#ABORT)
    //
    // * 'transaction' is MANDATORY.
    //
    // It is preferable to abort a transaction by calling 'abort()' directly on
    // the object returned by 'client.begin()':
    //
    //     var tx = client.begin(txid);
    //     ...
    //     tx.abort();
    var abort = function (transaction) {
        return frame_1.default.marshall('ABORT', { transaction: transaction });
    };
    // [ACK Frame](http://stomp.github.com/stomp-specification-1.1.html#ACK)
    //
    // * 'messageID' & 'subscription' are MANDATORY.
    //
    // It is preferable to acknowledge a message by calling 'ack()' directly
    // on the message handled by a subscription callback:
    //
    //     client.subscribe(destination,
    //       function(message) {
    //         // process the message
    //         // acknowledge it
    //         message.ack();
    //       },
    //       {'ack': 'client'}
    //     );
    var ack = function (messageID, subscription, headers) {
        return frame_1.default.marshall('ACK', __assign({}, headers, { 'message-id': messageID, subscription: subscription }));
    };
    // [SUBSCRIBE Frame](http://stomp.github.com/stomp-specification-1.1.html#SUBSCRIBE)
    var subscribe = function (headers) {
        return frame_1.default.marshall('SUBSCRIBE', headers);
    };
    // [UNSUBSCRIBE Frame](http://stomp.github.com/stomp-specification-1.1.html#UNSUBSCRIBE)
    //
    // * 'id' is MANDATORY.
    //
    // It is preferable to unsubscribe from a subscription by calling
    // 'unsubscribe()' directly on the object returned by 'client.subscribe()':
    //
    //     var subscription = client.subscribe(destination, onmessage);
    //     ...
    //     subscription.unsubscribe(headers);
    var unSubscribe = function (headers) {
        return frame_1.default.marshall('UNSUBSCRIBE', headers);
    };
    return { getMessageId: getMessageId, getSubscription: getSubscription, connect: connect, disconnect: disconnect, send: send, begin: begin, commit: commit, abort: abort, ack: ack, subscribe: subscribe, unSubscribe: unSubscribe };
};
exports.default = stompProtocolV1_0;
